import Api from '@/services/Api'
import GmwApi from '@/services/GmwApi'

export default {
    getall () {
        return Api().get('bills/getall')
    },
    printinvoice (id) {
        return Api().get('bills/printinvoice/'+id)
    },
    getebillid () {
        return Api().get('bills/getebillid')
    },
    getnum (year,con) {
        return Api().get('bills/getnum/'+year+'/'+con)
    },
    create (data) {
        return Api().post('bills/create', data)
    },
    update (data,id) {
        return Api().post('bills/update/'+id, data)
    },
    getbill (id) {
        return Api().get('bills/getbill/'+id)
    },
    getallgmwbills () {
        return Api().get('bills/getallgmwbills')
    },
    getsminputbills (startdate,enddate) {
        return Api().get('bills/getsminputbills/'+startdate+'/'+enddate)
    },

    //GMW
    getallgmw () {
        return GmwApi().get('bills/getall')
    },
    printinvoicegmw (id) {
        return GmwApi().get('bills/printinvoice/'+id)
    },
    getebillidgmw () {
        return GmwApi().get('bills/getebillid')
    },
    getnumgmw (year,con) {
        return GmwApi().get('bills/getnum/'+year+'/'+con)
    },
    creategmw (data) {
        return GmwApi().post('bills/create', data)
    },
    updategmw (data,id) {
        return GmwApi().post('bills/update/'+id, data)
    },
    getbillgmw (id) {
        return GmwApi().get('bills/getbill/'+id)
    },
    getgmsalesgmw (startdate,enddate) {
        return GmwApi().get('bills/getgmsales/'+startdate+'/'+enddate)
    },
}